<template>
  <LayoutAdmin>
    <div class="main-content">
      <section class="section">
        <div class="section-header">
          <h1>Detail Permohonan</h1>
          <div class="section-header-breadcrumb">
            <div class="breadcrumb-item active">
              <a href="#">Home</a>
            </div>
            <div class="breadcrumb-item">
              <a href="#">Detail Permohonan</a>
            </div>
          </div>
        </div>
        <div class="section-body">
          <div
            v-if="dataPermohonan.id_data_permohonan"
            class="card card-primary"
          >
            <div class="card-body">
              <!-- tombol kembali, upload surat pengantar -->
              <div class="row">
                <div class="col-6">
                  <router-link
                    :to="linkKembali"
                    tag="button"
                    class="btn btn-danger btn-sm"
                  >
                    <i class="fa fa-angle-left mr-2" />Kembali
                  </router-link>
                </div>
                <div class="col-6 text-right">
                  <!-- tombol cetak -->
                  <a
                    v-if="dataPermohonan.file_surat_pengantar"
                    :href="$store.getters.getBaseUrl+'/api/file/'+dataPermohonan.file_surat_pengantar"
                    class="btn btn-primary btn-sm"
                  ><i class="fa fa-print mr-2" />Cetak Surat Pengantar</a>

                  <!-- tombol upload jika kosong -->
                  <button
                    v-if="!dataPermohonan.file_surat_pengantar && namaRole === 'Operator Desa'"
                    class="btn btn-primary btn-sm"
                    @click="uploadSuratPengantar"
                    title="Upload Surat Pengantar"
                  >
                    <i class="fa fa-upload mr-2" />Upload Surat Pengantar
                  </button>

                  <!-- tombol upload jika kosong kades -->
                  <button
                    v-if="!dataPermohonan.file_surat_pengantar && namaRole === 'Kepala Desa'"
                    class="btn btn-primary btn-sm"
                    @click="uploadSuratPengantar"
                    title="Upload Surat Pengantar"
                  >
                    <i class="fa fa-upload mr-2" />Upload Surat Pengantar
                  </button>

                  <!-- tombol upload jika kosong -->
                  <button
                    v-if="!dataPermohonan.file_surat_pengantar && namaRole === 'Rumah Sakit'"
                    class="btn btn-primary btn-sm"
                    @click="uploadSuratPengantar"
                    title="Upload Surat Pengantar"
                  >
                    <i class="fa fa-upload mr-2" />Upload Surat Pengantar
                  </button>
                                    
                  <!-- tombol upload ulang -->
                  <button
                    v-if="dataPermohonan.file_surat_pengantar && namaRole === 'Operator Desa'"
                    class="btn btn-primary btn-sm"
                    @click="uploadSuratPengantar"
                    title="Upload Ulang Surat Pengantar"
                  >
                    <i class="fa fa-redo" />
                  </button>

                  <!-- tombol upload ulang kades -->
                  <button
                    v-if="dataPermohonan.file_surat_pengantar && namaRole === 'Kepala Desa'"
                    class="btn btn-primary btn-sm"
                    @click="uploadSuratPengantar"
                    title="Upload Ulang Surat Pengantar"
                  >
                    <i class="fa fa-redo" />
                  </button>
                          
                  <!-- tombol upload ulang -->
                  <button
                    v-if="dataPermohonan.file_surat_pengantar && namaRole === 'Rumah Sakit'"
                    class="btn btn-primary btn-sm"
                    @click="uploadSuratPengantar"
                    title="Upload Ulang Surat Pengantar"
                  >
                    <i class="fa fa-redo" />
                  </button>
                </div>
              </div>


              <!-- alert permohonan sudah selesai -->
              <div class="mt-3">
                <div v-if="dataPermohonan.status === 16">
                  <hr>
                  <div class="alert alert-success alert-has-icon mt-3">
                    <div class="alert-icon">
                      <i class="fas fa-check" />
                    </div>
                    <div class="alert-body">
                      <div class="alert-title">
                        Permohonan Sudah Selesai
                      </div>
                      Permohonan sudah dinyatakan selesai
                    </div>
                  </div>
                </div>
              </div>
                            
              <!-- header detail permohonan -->
              <div class="mt-3">
                <DetailPermohonanHeader />
              </div>
                            
              <!-- formulir online -->
              <div>
                <div v-if="dataPermohonan.is_form_online === 1">
                  <h4 class="section-title">
                    Formulir Online
                  </h4>
                  <hr>
                  <div class="alert alert-secondary text-dark alert-has-icon mt-3">
                    <div class="alert-icon">
                      <i class="far fa-lightbulb" />
                    </div>
                    <div class="alert-body">
                      <div class="alert-title">
                        Informasi
                      </div>
                      Terdapat formulir online yang diajukan pada permohonan ini.
                      <button
                        class="btn btn-primary btn-sm"
                        @click="toggleFormOnline"
                      >
                        <i class="fa fa-eye mr-2" />
                        {{ (showFormOnline) ? 'Tutup' : 'Lihat' }}
                      </button><br>
                      Jika diminta untuk mengubah file cetakan dari formulir online, dapat mengklik tombol
                      <button
                        class="btn btn-primary btn-sm"
                        @click="toggleCetakForm"
                      >
                        <i class="fa fa-file mr-2" />
                        {{ (showCetakForm) ? 'Tutup' : 'Lihat Cetakan' }}
                      </button><br>
                    </div>
                  </div>
                  <div v-if="showFormOnline">
                    <ListFormulir
                      :disabled-form="true"
                    />
                  </div>
                  <div v-if="showCetakForm">
                    <ListCetakForm />
                  </div>
                </div>
                                



                <h4 class="section-title">
                  Berkas
                </h4>
                <hr>
                <!--
                                    kalau mau full
                                    margin: 0px -25px;
                                    width: calc(100% + 50px);
                                -->
                <div class="table-responsive">
                  <ListBerkas />
                </div>

                <!--
                                    widget pernyataan revisi selesai
                                    jika Penduduk, jika status permohonan revisi
                                    tekan revisi selesai, statusnya diajukan ke XX
                                -->
                <div v-if="namaRole === 'Penduduk' || namaRole === 'Operator Desa' || namaRole === 'Rumah Sakit'">
                  <div v-if="dataPermohonan.status === 3 || dataPermohonan.status === 7 || dataPermohonan.status === 11">
                    <hr>
                                        
                    <div class="form-group row mt-3">
                      <label
                        for=""
                        class="col-form-label col-md-3 text-md-right text-left"
                      >Pernyataan Revisi Selesai</label>
                      <div class="col-md-9">
                        <button
                          class="btn btn-primary"
                          @click="revisiSelesai($event)"
                        >
                          <i class="fa fa-check mr-2" />Revisi Selesai
                        </button>
                        <div class="alert alert-primary alert-has-icon mt-3">
                          <div class="alert-icon">
                            <i class="far fa-lightbulb" />
                          </div>
                          <div class="alert-body">
                            <div class="alert-title">
                              Informasi
                            </div>
                            Jika anda sudah memperbaiki seluruh file, tekan tombol Revisi Selesai untuk mengajukan permohonan kembali
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>




                <div v-if="namaRole != 'Penduduk'">
                  <div v-if="bisaUploadBerkasTambahan">
                    <hr>
                    <div class="form-group row mt-3">
                      <label
                        for=""
                        class="col-form-label col-md-3 text-md-right text-left"
                      >Perlu berkas tambahan</label>
                      <div class="col-md-9">
                        <div class="alert alert-primary alert-has-icon mt-3">
                          <div class="alert-icon">
                            <i class="far fa-lightbulb" />
                          </div>
                          <div class="alert-body">
                            <div class="alert-title">
                              Informasi
                            </div>
                            Jika ada berkas yang kurang, operator dapat membuka tempat untuk upload berkas. Silahkan centang form perlu berkas tambahan,
                            lalu pilih berkas yang diperlukan.
                          </div>
                        </div>
                        <div class="custom-control custom-checkbox mb-3">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            id="konmfirmasiAdaBerkasTambahan"
                            v-model="konmfirmasiAdaBerkasTambahan"
                          >
                          <label
                            class="custom-control-label"
                            for="konmfirmasiAdaBerkasTambahan"
                          >Perlu Berkas Tambahan</label>
                        </div>
                        <v-select
                          multiple
                          v-model="berkasTambahan"
                          :options="syaratKurang"
                          label="nama_dokumen"
                          v-if="konmfirmasiAdaBerkasTambahan"
                        />
                        <button
                          v-if="konmfirmasiAdaBerkasTambahan"
                          class="btn btn-primary mt-3"
                          @click="berkasTambahanOperator($event)"
                        >
                          <i class="fa fa-check mr-2" />Simpan
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
                            
              <!-- Validasi oleh operator -->
              <DetailPermohonanValidasi />


              <!-- dokumen hasil -->
              <DetailPermohonanDokumenHasil
                @showPermohonan="showPermohonan"
              />

              <!-- Opsi Pengambilan dokumen hasil -->
              <DetailPermohonanOpsiAmbilDokHasil
                @showPermohonan="showPermohonan"
              />

              <!-- pernyataan permohonan selesai -->
              <div v-if="namaRole === 'Operator Dukcapil' || namaRole === 'Operator Dukcapil Kecamatan'">
                <div v-if="dataPermohonan.status === 15 && dataPermohonan.opsi_ambil_berkas != 0">
                  <hr>
                  <div class="form-group row">
                    <label
                      for=""
                      class="col-form-label col-md-3 text-md-right text-left"
                    >Permohonan Selesai</label>
                    <div class="col-md-9">
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="konfirmasiPermohonanSelesai"
                          v-model="konfirmasiPermohonanSelesai"
                        >
                        <label
                          class="custom-control-label"
                          for="konfirmasiPermohonanSelesai"
                        >Saya {{ ($store.getters.getUserProfile) ? $store.getters.getUserProfile.nama_lengkap : '' }} menyatakan permohonan sudah selesai</label>
                      </div>


                      <button
                        :disabled="!konfirmasiPermohonanSelesai"
                        class="btn btn-primary mt-3"
                        @click="setPermohonanSelesai($event)"
                      >
                        <i class="fa fa-check mr-2" />Permohonan Sudah Selesai
                      </button>
                                            
                      <div class="alert alert-primary alert-has-icon mt-3">
                        <div class="alert-icon">
                          <i class="far fa-lightbulb" />
                        </div>
                        <div class="alert-body">
                          <div class="alert-title">
                            Informasi
                          </div>
                          Konfirmasi Selesai menyatakan bahwa seluruh proses pengajuan permohonan oleh penduduk sudah selesai.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- detail status -->
              <div>
                <h4 class="section-title">
                  Detail Status
                </h4>
                <hr>
                <div>
                  <Timeline />
                </div>
              </div>
            </div>
            <!-- end card body -->
          </div>

          <!-- content loader -->
          <div v-else>
            <DetailPermohonanContentLoader />
          </div>
        </div>
      </section>

      <b-modal
        id="modal-upload-surat-pengantar"
        title="Upload Surat Pengantar"
      >
        <div class="form-group">
          <label for="">Nomor Surat</label>
          <input
            type="text"
            class="form-control"
            v-model="formSuratPengantar.nomor_surat_pengantar"
          >
          <small>Isikan nomor surat sebelum download template</small>
        </div>
        <a
          :href="$store.getters.getBaseUrl+'/api/dataPermohonanPenduduk/'+dataPermohonan.id_data_permohonan+'/downloadTemplateSuratPengantar?nomor_surat_pengantar='+formSuratPengantar.nomor_surat_pengantar"
          class="btn btn-primary btn-sm mb-2"
          target="_blank"
        >
          <i class="fa fa-download mr-2" />Download Template
        </a>
        <p>Download template surat pengantar dengan mengklik tombol diatas. Isi lalu tanda tangani, kemudian scan dan upload kembali.</p>
        <div class="form-group">
          <input
            type="file"
            class="form-control"
            @change="selectFileSuratPengantar"
            accept="application/pdf"
          >
          <div
            class="progress mt-3"
            v-if="loading"
          >
            <div
              class="progress-bar progress-bar-striped progress-bar-animated"
              role="progressbar"
              :aria-valuenow="uploadProgress"
              aria-valuemin="0"
              aria-valuemax="100"
              :style="{width: uploadProgress+'%'}"
            />
          </div>
        </div>
                
        <template #modal-footer>
          <button
            type="button"
            class="btn btn-primary"
            @click="submitUploadFileSuratPengantar($event)"
          >
            <i class="fa fa-check mr-2" />Upload
          </button>
        </template>
      </b-modal>
    </div>
  </LayoutAdmin>
</template>

<script>
import swal from 'sweetalert'
import LayoutAdmin from './../layouts/Admin.vue'
import DetailPermohonanHeader from './../../components/detailpermohonan/DetailPermohonanHeader.vue'
import DetailPermohonanValidasi from './../../components/detailpermohonan/DetailPermohonanValidasi.vue'
import DetailPermohonanDokumenHasil from './../../components/detailpermohonan/DetailPermohonanDokumenHasil.vue'
import DetailPermohonanOpsiAmbilDokHasil from './../../components/detailpermohonan/DetailPermohonanOpsiAmbilDokHasil.vue'
import DetailPermohonanContentLoader from './../../components/detailpermohonan/DetailPermohonanContentLoader.vue'
import ListCetakForm from './../../components/global/ListCetakForm.vue'
import ListFormulir from './../../components/global/ListFormulir.vue'
import ListBerkas from './../../components/global/ListBerkas.vue'
import Timeline from './../../components/global/Timeline.vue'

export default {
  data() {
    return {
      formSuratPengantar: {
        file: null,
        nomor_surat_pengantar: ''
      },
      konfirmasiPermohonanSelesai: false, // checkbox untuk enable tombol permohonan sudah selesai
      berkasTambahan: null, // jika di operator, trus ada berkas yg kurang, dikasi form select untuk pilih apa aja yg kurang,
      syaratKurang: [],
      konmfirmasiAdaBerkasTambahan: false,
      showFormOnline: false,
      showCetakForm: false,
      loading: false, // loading upload surat pengantar
      uploadProgress: 0 // upload progress surat pengantar
    }
  },
  computed: {
    namaRole() {
      return this.$store.getters.getAuthService.currentRole.nama_role
    },
    dataPermohonan() {
      return this.$store.getters.getDataPermohonan
    },
    filePermohonan() {
      return this.$store.getters.getFilePermohonan
    },
    selectedPaket() {
      return this.$store.getters.getSelectedPaket
    },
    hasilPermohonan() {
      return this.$store.getters.getHasilPermohonan
    },
    bisaUploadBerkasTambahan() {
      let bisaUpload = false
      if (this.namaRole === 'Penduduk') {
        bisaUpload = false
      } else if (this.namaRole === 'Operator Desa' || this.namaRole === 'Kepala Desa' || this.namaRole === 'Rumah Sakit') {
        if (this.dataPermohonan.status == 2) {
          bisaUpload = true
        } else {
          bisaUpload = false
        }
      } else if (this.namaRole === 'Operator Kecamatan') {
        if (this.dataPermohonan.status == 6) {
          bisaUpload = true
        } else {
          bisaUpload = false
        }
      } else if (this.namaRole === 'Operator Dukcapil' || this.namaRole === 'Operator Dukcapil Kecamatan') {
        if (this.dataPermohonan.status == 10) {
          bisaUpload = true
        } else {
          bisaUpload = false
        }
      }
      return bisaUpload
    },
    linkKembali () {
      let link = '/permohonan/data-permohonan'
      if (this.$store.getters.getBackTo) {
        if (this.$store.getters.getBackTo === 'data-permohonan') {
          link = '/permohonan/data-permohonan'
        } else if(this.$store.getters.getBackTo === 'riwayat-input') {
          link = '/permohonan/riwayat-input'
        }
      }
      return link
    }
  },
  components: {
    LayoutAdmin, DetailPermohonanHeader, DetailPermohonanValidasi, DetailPermohonanDokumenHasil,
    DetailPermohonanOpsiAmbilDokHasil, DetailPermohonanContentLoader,
    ListBerkas, Timeline, ListFormulir, ListCetakForm
  },
  methods: {
    showPermohonan() {
      // reset dulu, baru show lagi
      let resetPermohonan = { tahap: 1 }
      this.$store.dispatch('setDataPermohonan', resetPermohonan)

      if (this.namaRole === 'Penduduk') {
        this.$store.dispatch('showDataPermohonanPenduduk', this.$route.params.id)
      } else if (this.namaRole === 'Operator Desa' || this.namaRole === 'Kepala Desa') {
        this.$store.dispatch('showDataPermohonanPendudukByDesa', this.$route.params.id)
      } else if (this.namaRole === 'Operator Kecamatan') {
        this.$store.dispatch('showDataPermohonanPendudukByKecamatan', this.$route.params.id)
      } else if (
        this.namaRole === 'Operator Dukcapil' ||
        this.namaRole === 'Operator Dukcapil Kecamatan' ||
        this.namaRole === 'Admin Laksita' ||
        this.namaRole === 'Admin Jembrana'
        ) {
        this.$store.dispatch('showDataPermohonanPendudukByDukcapil', this.$route.params.id)
      } else if (this.namaRole === 'Rumah Sakit') {
        this.$store.dispatch('showDataPermohonanPendudukByRumahSakit', this.$route.params.id)
      }
    },
    selectFileSuratPengantar(e) {
      this.formSuratPengantar.file = e.target.files[0]
    },
    uploadSuratPengantar() {
      this.$bvModal.show('modal-upload-surat-pengantar')
    },
    submitUploadFileSuratPengantar(e) {
      let button = e.target
      let buttonHtml = button.innerHTML

      button.setAttribute('disabled', true)
      button.innerHTML = '<i class="fa fa-spin fa-spinner mr-2"></i>Upload'

      let formData = new FormData()
      formData.append('file_surat_pengantar', this.formSuratPengantar.file)

      this.$store.dispatch('uploadSuratPengantar', { id: this.dataPermohonan.id_data_permohonan, form: formData }).then(res => {
        if (res.data.status) {
          swal({
            title: "Berhasil",
            text: res.data.message,
            icon: "success",
            buttons: "Ok"
          })
          this.showPermohonan()
          this.$bvModal.hide('modal-upload-surat-pengantar')
        } else {
          swal({
            title: "Gagal",
            text: res.data.message,
            icon: "error",
            buttons: "Ok"
          })
        }
        button.removeAttribute('disabled')
        button.innerHTML = buttonHtml

      }).catch(err => {
        // console.log(err)
        switch (err.response.status) {
          case 500:
            this.$router.push({ path: '/500' })
            break;

          case 400:
            swal({
              title: "Gagal",
              text: (typeof (err.response.data.message) === 'object') ? 'Ada kesalahan teknis. Harap hubungi operator' : err.response.data.message,
              icon: "error",
              buttons: "Ok"
            })
            break;

          default:
            swal({
              title: "Gagal",
              text: err.response.data.message,
              icon: "error",
              buttons: "Ok"
            })
            break;
        }
        button.removeAttribute('disabled')
        button.innerHTML = buttonHtml
      })
    },
    berkasTambahanOperator(e) {
      let button = e.target
      let buttonHtml = button.innerHTML

      button.setAttribute('disabled', true)
      button.innerHTML = '<i class="fa fa-spin fa-spinner mr-2"></i>Simpan'

      let formData = new FormData()
      let arrIdDokumen = []
      this.berkasTambahan.forEach(e => {
        arrIdDokumen.push(e.id_dokumen)
      })
      formData.append('id_dokumen', arrIdDokumen)
      formData.append('id_data_permohonan', this.dataPermohonan.id_data_permohonan)

      // console.log('arrIdDokumen', arrIdDokumen)

      this.$store.dispatch('setBerkasTambahan', formData).then(res => {
        if (res.data.status) {
          swal({
            title: "Berhasil",
            text: res.data.message,
            icon: "success",
            buttons: "Ok"
          })
          this.showPermohonan()

        } else {
          swal({
            title: "Gagal",
            text: res.data.message,
            icon: "error",
            buttons: "Ok"
          })
        }
        button.removeAttribute('disabled')
        button.innerHTML = buttonHtml
      }).catch(err => {
        switch (err.response.status) {
          case 500:
            this.$router.push({ path: '/500' })
            break;

          case 400:
            swal({
              title: "Gagal",
              text: (typeof (err.response.data.message) === 'object') ? 'Ada kesalahan teknis. Harap hubungi operator' : err.response.data.message,
              icon: "error",
              buttons: "Ok"
            })
            break;

          default:
            swal({
              title: "Gagal",
              text: err.response.data.message,
              icon: "error",
              buttons: "Ok"
            })
            break;
        }
        button.removeAttribute('disabled')
        button.innerHTML = buttonHtml
      })
    },
    setPermohonanSelesai(e) {
      let button = e.target
      let buttonHtml = button.innerHTML

      button.setAttribute('disabled', true)
      button.innerHTML = '<i class="fa fa-spin fa-spinner mr-2"></i>Permohonan Sudah Selesai'

      let formData = new FormData()
      formData.append('status', 16)

      if (this.namaRole === 'Operator Desa' || this.namaRole === 'Rumah Sakit') {
        formData.append('is_operator_desa', 1)
      } else if (this.namaRole === 'Operator Dukcapil' || this.namaRole === 'Operator Dukcapil Kecamatan') {
        formData.append('is_operator_dukcapil', 1)
      }

      let idDataPermohonan = this.dataPermohonan.id_data_permohonan

      this.$store.dispatch('updatePermohonanPenduduk', { id: idDataPermohonan, form: formData }).then(res => {
        if (res.data.status) {
          swal({
            title: "Berhasil",
            text: "Permohonan sudah selesai",
            icon: "success",
            buttons: "Ok"
          })

          this.notify({
            type_notif: 'STATUS_PERMOHONAN',
            type_receiver: 'penduduk',
            id_penduduk: this.dataPermohonan.id_penduduk,
            id_data_permohonan: idDataPermohonan,
            status_permohonan: 16,
            via: 'fcm',
            title_notif: 'Permohonan Selesai',
            body_notif: `Permohonan ${this.dataPermohonan.paket_layanan.layanan.nama_layanan} yang anda ajukan sudah selesai. Terima kasih.`
          })

          this.showPermohonan()

        } else {
          swal({
            title: "Gagal",
            text: res.data.message,
            icon: "error",
            buttons: "Ok"
          })
        }



        button.removeAttribute('disabled')
        button.innerHTML = buttonHtml
      }).catch(err => {
        // console.log(err)
        switch (err.response.status) {
          case 500:
            this.$router.push({ path: '/500' })
            break;

          case 400:
            swal({
              title: "Gagal",
              text: (typeof (err.response.data.message) === 'object') ? 'Ada kesalahan teknis. Harap hubungi operator' : err.response.data.message,
              icon: "error",
              buttons: "Ok"
            })
            break;

          default:
            swal({
              title: "Gagal",
              text: err.response.data.message,
              icon: "error",
              buttons: "Ok"
            })
            break;
        }
        button.removeAttribute('disabled')
        button.innerHTML = buttonHtml
      })
    },
    revisiSelesai(e) {
      if (this.namaRole != 'Penduduk') {
        if ((this.namaRole === 'Operator Desa' || this.namaRole === 'Rumah Sakit') && this.dataPermohonan.id_operator_pembantu) {
          // ok
        } else {
          swal({
            title: "Gagal",
            text: "Anda tidak memiliki izin",
            icon: "error",
            buttons: "Ok"
          })
          return false
        }
      }
      let button = e.target
      let buttonHtml = button.innerHTML

      button.setAttribute('disabled', true)
      button.innerHTML = '<i class="fa fa-spin fa-spinner mr-2"></i>Revisi Selesai'

      let statusDiajukan = 1

      if (this.dataPermohonan.status === 3) { // jika revisi tingkat desa
        statusDiajukan = 1 // diajukan ke desa kembali
      } else if (this.dataPermohonan.status === 7) {
        statusDiajukan = 5 // diajukan ke kecamatan
      } else if (this.dataPermohonan.status === 11) {
        statusDiajukan = 9 // diajukan ke dukcapil
      }

      let formData = new FormData()
      formData.append('status', statusDiajukan)

      if (this.namaRole === 'Operator Desa' || this.namaRole === 'Kepala Desa' || this.namaRole === 'Rumah Sakit') {
        formData.append('is_operator_desa', '1')
      }

      let idDataPermohonan = this.dataPermohonan.id_data_permohonan

      this.$store.dispatch('updatePermohonanPenduduk', { id: idDataPermohonan, form: formData }).then(res => {
        if (res.data.status) {
          swal({
            title: "Berhasil",
            text: "Berhasil mengajukan permohonan kembali",
            icon: "success",
            buttons: "Ok"
          })
          let typeReceiver = 'operator_desa'
          if (statusDiajukan == 1) {
            typeReceiver = 'operator_desa'
          } else if (statusDiajukan == 5) {
            // not supported
          } else if (statusDiajukan == 9) {
            typeReceiver = 'operator_dukcapil'
          }
          this.notify({
            type_notif: 'STATUS_PERMOHONAN',
            type_receiver: typeReceiver,
            id_data_permohonan: idDataPermohonan,
            status_permohonan: statusDiajukan,
            via: 'mail,fcm',
            title_notif: 'Permohonan Telah Diperbaiki',
            body_notif: `Permohonan ${this.dataPermohonan.paket_layanan.layanan.nama_layanan} dari ${this.$store.getters.getUserProfile.nama_lengkap} telah diperbaiki`
          })

          this.showPermohonan()

        } else {
          swal({
            title: "Gagal",
            text: res.data.message,
            icon: "error",
            buttons: "Ok"
          })
        }
        button.removeAttribute('disabled')
        button.innerHTML = buttonHtml
      }).catch(err => {
        switch (err.response.status) {
          case 500:
            this.$router.push({ path: '/500' })
            break;

          case 400:
            swal({
              title: "Gagal",
              text: (typeof (err.response.data.message) === 'object') ? 'Ada kesalahan teknis. Harap hubungi operator' : err.response.data.message,
              icon: "error",
              buttons: "Ok"
            })
            break;

          default:
            swal({
              title: "Gagal",
              text: err.response.data.message,
              icon: "error",
              buttons: "Ok"
            })
            break;
        }
        button.removeAttribute('disabled')
        button.innerHTML = buttonHtml
      })
    },
    toggleFormOnline() {
      this.showFormOnline = !this.showFormOnline
    },
    toggleCetakForm() {
      this.showCetakForm = !this.showCetakForm
    },
    notify(data) {
      let formData = new FormData
      for (let key in data) {
        formData.append(key, data[key])
      }

      this.$store.dispatch('sendNotifikasi', formData).then(r => {
        // console.log(r)
      })
    },
    setDokumenHasil() {
      if (this.namaRole === 'Penduduk') {
        this.$store.dispatch('fetchHasilPermohonan', this.dataPermohonan.id_data_permohonan).then(res => {
          if (res.data.status) {
            this.$store.dispatch('setHasilPermohonan', res.data.data)
          }
        })
      } else if (
        this.namaRole === 'Operator Desa' ||
        this.namaRole === 'Rumah Sakit' ||
        this.namaRole === 'Kepala Desa' ||
        this.namaRole === 'Operator Kecamatan' ||
        this.namaRole === 'Operator Dukcapil' ||
        this.namaRole === 'Operator Dukcapil Kecamatan' ||
        this.namaRole === 'Admin Laksita' ||
        this.namaRole === 'Admin Jembrana'
      ) {
        this.$store.dispatch('fetchHasilPermohonanByOperator', this.dataPermohonan.id_data_permohonan).then(res => {
          if (res.data.status) {
            this.$store.dispatch('setHasilPermohonan', res.data.data)
          }
        })
      }
    }
  },
  mounted() {
    this.showPermohonan()
  },
  watch: {
    dataPermohonan(newVal) {
      if (!newVal.id_data_permohonan) {
        return false
      }

      // refresh supaya berubah status: belum diproses => sedang diproses
      if (this.namaRole === 'Operator Desa' || this.namaRole === 'Kepala Desa' || this.namaRole === 'Rumah Sakit') {
        if (this.dataPermohonan.status === 1) {
          window.location = ''
        }
      } else if (this.namaRole === 'Operator Kecamatan') {
        if (this.dataPermohonan.status === 5) {
          window.location = ''
        }
      } else if (this.namaRole === 'Operator Dukcapil' || this.namaRole === 'Operator Dukcapil Kecamatan') {
        if (this.dataPermohonan.status === 9) {
          window.location = ''
        }
      }

      // select paket
      let paket = newVal.paket_layanan.paket
      paket.output_dok = paket.output_dok.split(',')
      this.$store.dispatch('selectPaket', paket)





      // set syarat kurang jika operator
      if (this.namaRole != 'Penduduk' && this.filePermohonan) {
        let widget = []
        newVal.paket_layanan.layanan.layanan_dokumen.forEach(e => {
          if (this.filePermohonan.findIndex(f => f.id_dokumen === e.id_dokumen) === -1) {
            widget.push(e.dokumen)
          }
        })
        // console.log(widget)

        this.syaratKurang = widget
      }





      // set form surat pengantar, nomornya
      this.formSuratPengantar.nomor_surat_pengantar = newVal.nomor_surat_pengantar




      // show riwayat permohonan
      // 5 oct: lupa ini untuk apa
      this.$store.dispatch('showRiwayatDataPermohonan', newVal.id_data_permohonan).then(res => {
        if (res.data.status) {
          this.$store.dispatch('setRiwayatDataPermohonan', res.data.data)
        }
      })


      // hasil dokumen
      this.setDokumenHasil()
    },
    filePermohonan(newVal) {
      // set syarat kurang jika operator
      if (this.namaRole != 'Penduduk' && this.dataPermohonan) {
        let widget = []
        this.dataPermohonan.paket_layanan.layanan.layanan_dokumen.forEach(e => {
          if (newVal.findIndex(f => f.id_dokumen === e.id_dokumen) === -1) {
            widget.push(e.dokumen)
          }
        })
        // console.log(widget)

        this.syaratKurang = widget
      }
    }
  }
}
</script>